module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/th/4-0850bbefa4fe5d75c37c4550a8b9a425.jpg";